import React, { Component } from "react";

import { StyleSheet, Content, Navigator } from "react-1app";

import Login from "./Login.js";
import Novidades from "./Novidades.js";
import Garantia from "./Garantia.js";
import Manual from "./Manual.js";
import Receitas from "./Receitas.js";
import Init from "./Init.js";
import Gerenciador from "./Gerenciador.js";


export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { user_local: false };
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    return (
      <Content style={styles.content}>
        {!this.state.user_local ? (
          <Login
            style={styles.fragment1}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}

        {this.state.user_local && this.state.pageInit ? (
          <Init
            style={styles.fragment2}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}

        {this.state.user_local && this.state.pageGarantia ? (
          <Garantia
            style={styles.fragment2}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}

        {this.state.user_local && this.state.pageManual ? (
          <Manual
            style={styles.fragment2}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}


        {this.state.user_local && this.state.pageGerenciador ? (
          <Gerenciador
            style={styles.fragment2}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}

        {this.state.user_local && this.state.pageReceitas ? (
          <Receitas
            style={styles.fragment2}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}

        {this.state.user_local && this.state.pageNovidades ? (
          <Novidades
            style={styles.fragment2}
            screenProps={this.props.screenProps}
            navigation={this.props.navigation}
            activity={this}
            oldState={this.state}
          />
        ) : null}


      </Content>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(255,255,255,1)",
    alignSelf: "flex-start",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    flex: 1
  },
  fragment1: {
    alignSelf: "stretch",
    flex: 1
  },
  fragment2: {
    alignSelf: "stretch",
    flex: 1
  }
});



// WEBPACK FOOTER //
// ./src/views/Home.js